"use client";

import { useState } from "react";

import TeamCard from "./TeamCard";
import TeamModal from "./TeamModal";

interface TeamCardWrapperProps {
    members: TeamMember[];
}

export default function TeamCardWrapper({ members }: TeamCardWrapperProps) {
    const [selectedMember, setSelectedMember] = useState<TeamMember | null>(
        null,
    );

    const handleModalOpen = (member: TeamMember) => {
        setSelectedMember(member);
    };

    const handleModalClose = () => {
        setSelectedMember(null);
    };

    return (
        <>
            {members.map((member, index) => (
                <TeamCard
                    key={index}
                    member={member}
                    onSelect={handleModalOpen}
                />
            ))}

            {selectedMember && (
                <TeamModal member={selectedMember} onClose={handleModalClose} />
            )}
        </>
    );
}
